export enum UserGroups {
  GINGR = 'gingr',
  ESTABLISHMENT = 'establishment',
  AGENCY = 'agency'
}
